module.exports = __webpack_public_path__ + "img/yuanmingyuan big (4).5dec8f69.jpg";